import { SessionBlockAthleteNoteEntity } from "@/modules/sessions/entities/sessionBlockAthleteNoteEntity"
import { SessionBlockCoachNoteEntity } from "@/modules/sessions/entities/sessionBlockCoachNoteEntity"
import { SessionBlockExerciseEntity } from "@/modules/sessions/entities/sessionBlockExerciseEntity"
import { SessionBlockMediaEntity } from "@/modules/sessions/entities/sessionBlockMediaEntity"
import type { BlockSessionInputDto, SessionBlockDto } from "@/modules/sessions/gateway/sessionBlockDto"
import { SessionBlockType } from "@/modules/sessions/sessionDetails/sessionBlockTypes"
import type { SessionBlockFormikType } from "@/modules/sessions/sessionForm/sessionBlockFormikTypes"
import type { EditExerciseTemplateInputDto } from "@/modules/template/gateway/templateDto"

export type SessionBlockMediasType = {
  type: typeof SessionBlockType.MEDIAS
  content: SessionBlockMediaEntity
}
export type SessionBlockExerciseType = {
  type: typeof SessionBlockType.SESSION_EXERCISE
  content: SessionBlockExerciseEntity
}
export type SessionBlockCoachNoteType = {
  type: typeof SessionBlockType.COACH_NOTE
  content: SessionBlockCoachNoteEntity
}
export type SessionBlockAthleteNoteType = {
  type: typeof SessionBlockType.ATHLETE_NOTE
  content: SessionBlockAthleteNoteEntity
}

export type SessionBlockEntityType =
  | SessionBlockMediasType
  | SessionBlockExerciseType
  | SessionBlockCoachNoteType
  | SessionBlockAthleteNoteType

export const SessionBlockEntityFactory = {
  fromDto: (dto: SessionBlockDto): SessionBlockEntityType => {
    if (dto.type === SessionBlockType.MEDIAS) {
      return {
        type: dto.type,
        content: SessionBlockMediaEntity.fromDto(dto.content),
      }
    }
    if (dto.type === SessionBlockType.SESSION_EXERCISE) {
      return {
        type: dto.type,
        content: SessionBlockExerciseEntity.fromDto(dto.content),
      }
    }
    if (dto.type === SessionBlockType.COACH_NOTE) {
      return {
        type: dto.type,
        content: SessionBlockCoachNoteEntity.fromDto(dto.content),
      }
    }
    /*if (dto.type === SessionBlockType.ATHLETE_NOTE) */
    return {
      type: dto.type,
      content: SessionBlockAthleteNoteEntity.fromDto(dto.content),
    }
  },
  fromEntityToFormik: (entity: SessionBlockEntityType): SessionBlockFormikType => {
    if (entity.type === SessionBlockType.MEDIAS) {
      return {
        type: entity.type,
        content: SessionBlockMediaEntity.fromEntityToFormik(entity.content),
      }
    }
    if (entity.type === SessionBlockType.SESSION_EXERCISE) {
      return {
        type: entity.type,
        content: SessionBlockExerciseEntity.fromEntityToFormik(entity.content),
      }
    }
    if (entity.type === SessionBlockType.COACH_NOTE) {
      return {
        type: entity.type,
        content: SessionBlockCoachNoteEntity.fromEntityToFormik(entity.content),
      }
    }
    // if (entity.type === SessionBlockType.ATHLETE_NOTE)
    return {
      type: entity.type,
      content: SessionBlockAthleteNoteEntity.fromEntityToFormik(entity.content),
    }
  },
  fromEntityToInputDto: (entity: SessionBlockEntityType): BlockSessionInputDto => {
    if (entity.type === SessionBlockType.MEDIAS) {
      return {
        type: entity.type,
        content: SessionBlockMediaEntity.fromEntityToInputDto(entity.content),
      }
    }
    if (entity.type === SessionBlockType.SESSION_EXERCISE) {
      return {
        type: entity.type,
        content: SessionBlockExerciseEntity.fromEntityToInputDto(entity.content),
      }
    }
    if (entity.type === SessionBlockType.COACH_NOTE) {
      return {
        type: entity.type,
        content: SessionBlockCoachNoteEntity.fromEntityToInputDto(entity.content),
      }
    }
    // if (entity.type === SessionBlockType.ATHLETE_NOTE) {
    return {
      type: entity.type,
      content: SessionBlockAthleteNoteEntity.fromEntityToInputDto(entity.content),
    }
  },
  fromFormikToInputDto: (formik: SessionBlockFormikType, orderIndex: number): BlockSessionInputDto => {
    if (formik.type === SessionBlockType.MEDIAS) {
      return {
        type: formik.type,
        content: SessionBlockMediaEntity.fromFormikToInputDto(formik.content, orderIndex),
      }
    }
    if (formik.type === SessionBlockType.SESSION_EXERCISE) {
      return {
        type: formik.type,
        content: SessionBlockExerciseEntity.fromFormikToInputDto(formik.content, orderIndex),
      }
    }
    if (formik.type === SessionBlockType.COACH_NOTE) {
      return {
        type: formik.type,
        content: SessionBlockCoachNoteEntity.fromFormikToInputDto(formik.content, orderIndex),
      }
    }
    // if (formik.type === SessionBlockType.ATHLETE_NOTE)
    return {
      type: formik.type,
      content: SessionBlockAthleteNoteEntity.fromFormikToInputDto(formik.content, orderIndex),
    }
  },
  fromFormikToTemplateBlockInputDto: (formik: SessionBlockFormikType): EditExerciseTemplateInputDto => {
    if (formik.type === SessionBlockType.SESSION_EXERCISE) {
      return SessionBlockExerciseEntity.fromFormikToTemplateInputDto(formik.content)
    }
    throw new Error(`Invalid session block type: ${JSON.stringify(formik)}`)
  },
}
